// extracted by mini-css-extract-plugin
export default {"list":"TicketMessageList_list__wWCAi"};